import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";

interface grossData{
  total_units:number|null;
}

interface grossSalesState {
  data: grossData;
  status: string;
  statusCode: number;
  error: string | null;
  isLoading: boolean;
  selectedRow:any;
}
const initialState: grossSalesState = {
  data: {
    total_units:null,
  },
  selectedRow:{},
  status: "",
  error: null,
  statusCode: 0,
  isLoading: false,
};

export const FetchgrossSales = createAsyncThunk(
  "FetchgrossSales",
  async (data:any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.GETGROSSSALES,data);
      return response;
    } catch (err: any) {
    //   if (err.response && err.response.data) {
        return rejectWithValue(err);
    //   }
    //   return rejectWithValue("error occurred");
    }
  }
);

const grossSalesSlice = createSlice({
  name: "grossSalesData",
  initialState,
  reducers: {
    grossUpdateRow:(state,action)=>{
      state.selectedRow=action.payload
    },
    emptyGrossData:(state) => {
        state.data = initialState.data;
        state.error = initialState.error;
        state.isLoading = initialState.isLoading;
        state.selectedRow = initialState.selectedRow;
        state.status = initialState.status;
        state.statusCode = initialState.statusCode;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(FetchgrossSales.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(FetchgrossSales.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.statusCode = action.payload.status;
        state.data = action.payload.data;
      })
      .addCase(FetchgrossSales.rejected, (state,action:PayloadAction<any>) => {
        state.isLoading = false;
        state.statusCode = action.payload.status;
        state.data.total_units = null;
        state.status = "Failed";
        state.error = "Error";
      });
  },
});
export const { grossUpdateRow, emptyGrossData }=grossSalesSlice.actions
export default grossSalesSlice.reducer